import { connect } from 'react-redux'
import get from 'lodash/get'

import ScanIndicator from './ScanIndicator'

const mapStateToProps = (state) => ({
  ismpStatus: get(state.device, ['resources', 'ismp', 'status']),
  externalBarcodeIsAvailable: get(state.device, [
    'resources',
    'externalBarcode',
    'available',
  ]),
})

export default connect(mapStateToProps)(ScanIndicator)
